/**
 * Egy adott dátumból kivon/hozzáad egy adott mennyiségű napot.
 * @param {string} date      - A dátum amiből ki akarunk vonni.
 * @param {'+' | '-'} operation - Milyen operációt szeretnénk végrehajtani a dátumon.
 * @param {number} dayCount  - Azon napok száma, ahány napot szeretnénk kivonni.
 * @returns {number} Az új dátum, milliszekundumban.
 */
module.exports.addSubDays = function addSubDays (date, operation, dayCount) {
  const dateFormat = new Date(date)

  if (operation === '+') {
    dateFormat.setDate(dateFormat.getDate() + dayCount)
  }
  else if (operation === '-') {
    dateFormat.setDate(dateFormat.getDate() - dayCount)
  }

  return dateFormat.getTime()
}
